import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ItemBasicInfo} from './domain/item';
import {appConfig} from './app.config';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryDispatcherService {

  constructor(private http: HttpClient) { }

  public getItemBasicInfoByEquipId(equipId: number): Observable<ItemBasicInfo> {
    const url = `/api/item/equipment/${equipId}/basic-info`;
    return this.http.get<ItemBasicInfo>(url, appConfig.httpOptions)
      .pipe(
        catchError(() => HttpRequestErrorHandler.handleError('getItemBasicInfoByEquipId')),
        tap(data => ItemBasicInfo.fromJson(data))
      );
  }

  public getItemBasicInfoByAssetId(assetId: number): Observable<ItemBasicInfo> {
    const url = `/api/item/assets/${assetId}/basic-info`;
    return this.http.get<ItemBasicInfo>(url, appConfig.httpOptions)
      .pipe(
        catchError(() => HttpRequestErrorHandler.handleError('getItemBasicInfoByAssetId')),
        tap(data => ItemBasicInfo.fromJson(data))
      );
  }
}
